export const OPEN_MODAL = "OPEN_MODAL"
export const CLOSE_MODAL = "CLOSE_MODAL"
export const INVOICE_FETCH = "INVOICE_FETCH"
export const INVOICE_FETCH_SUCCESS = `${INVOICE_FETCH}_SUCCESS`
export const INVOICE_FETCH_FAILURE = `${INVOICE_FETCH}_FAILURE`
export const INVOICE_FETCH_CALL = `${INVOICE_FETCH}_CALL`
export const SET_INVOICE = "SET_INVOICE"
export const CLEAR_INVOICE = "CLEAR_INVOICE"
